
import httpClient from "@/plugins/axios";
import { JsonWebTokenError } from "jsonwebtoken";

export const getFeedbackCategories = async () => {
    const response = await httpClient.get("/v2/feedback/categories/");
    return response;
}

export const getCategoryForm = async (categoryId) => {
    const response = await httpClient.get(`/v1/feedback/categories/${categoryId}/form/`);
    return response;
}

export const saveFeedback = async (feedback) => {
    const response = await httpClient.post("/v2/feedback/", feedback);
    return response;
}

export const saveFeedbackAttachment = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('attachment_name', file.name);

    const response = await httpClient.post("/v2/feedback/attachments/", formData);
    return response;
}

export const deleteFeedbackAttachment = async (id) => {
    const response = await httpClient.delete(`/v2/feedback/attachments/${id}/`);
    return response;
}

export const getFeedbackPolicy = async () => {
    const response = await httpClient.get("/v1/settings/feedback-policy/");
    return response;
}

export const getMyFeedbacks = async (page = 1, pageSize = 20) => {
    const response = await httpClient.get("/v2/my/feedback", {
        params: { page, page_size: pageSize }
    });
    return response;
}

export const getMyFeedback = async (id) => {
    const response = await httpClient.get(`/v1/my/feedback/${id}`);
    return response;
}

export const saveMyFeedbackmessage = async (id, message) => {
    const response = await httpClient.post(`/v1/my/feedback/${id}/messages`,
        {
            feedback: id,
            text: message
        });
    return response;
}